import { Component, OnInit } from '@angular/core';
import { APPCONFIG } from '../../config';

@Component({
  selector: 'partial-footer',
  styles: [],
  templateUrl: './footer.component.html'
})

export class AppFooterComponent implements OnInit {
  public AppConfig: any;

  ngOnInit() {
    this.AppConfig = APPCONFIG;
  }
}



// WEBPACK FOOTER //
// /Users/jihun.lee/Work/git-repos/client-accounting-intra-web/src/app/layout/footer/footer.component.ts